import MemberDialog from 'components/Application/TeamMemberForm/MemberDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { CONFIRM_REMOVE_CI_DELEGATION, TEAM_MEMBER_EXIST, THREE_SITE_PI_ALLOWED } from 'utility/frontendMessage';
import { ciDelegationColumns, compareEmail } from 'utility/general';

const SLayout = styled.div``;

const CiDelegationEdit = ({
    isTableLoading = false,
    delegationData,
    piEmailList = [],
    onCiDelegateUpdate = () => null,
    onCiDelegateAdd = () => null,
    onCiDelegateRemove = () => {},
}) => {
    const [isCiDelegateAddShow, setCiDelegationAddShow] = useState(false);
    const [isCiDelegationEdit, setCiDelegationEdit] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const showDialog = useDialog();

    const onCiDelegationAdd = async (data) => {
        const isExist = delegationData.some((item) => compareEmail(item.email, data.email));

        if (isExist) {
            return showDialog({
                description: TEAM_MEMBER_EXIST,
                disableCancelButton: true,
            });
        }

        onCiDelegateAdd(data);
        setCiDelegationAddShow(false);
    };

    const onEdit = (data) => {
        setSelectedRow(data);
        setCiDelegationAddShow(true);
        setCiDelegationEdit(true);
    };

    const onCiDelegationSubmit = (data) => {
        if (!isCiDelegationEdit) {
            const isExist = delegationData.some((item) => compareEmail(item.email, data.email));

            if (isExist) {
                return showDialog({
                    description: TEAM_MEMBER_EXIST,
                    disableCancelButton: true,
                });
            }
        }

        onCiDelegateUpdate(data);
        setCiDelegationAddShow(false);
    };

    const onCiDelegateDelete = async (data) => {
        const isConfirm = await showDialog({
            description: CONFIRM_REMOVE_CI_DELEGATION,
        });

        if (isConfirm) {
            onCiDelegateRemove(data);
        }
    };

    return (
        <SLayout>
            {isCiDelegateAddShow && (
                <MemberDialog
                    title={isCiDelegationEdit ? 'Edit Delegation' : `Adding coordinating investigator's delegation`}
                    isDelegateDialog
                    restrictApplicant
                    selectedRow={selectedRow}
                    onDialogCancel={() => setCiDelegationAddShow(false)}
                    onCreateSubmit={onCiDelegationAdd}
                    onEditSubmit={onCiDelegationSubmit}
                    isEdit={isCiDelegationEdit}
                />
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <TextHeader>Coordinating Investigator delegations</TextHeader>
                <CustomButton
                    onClick={async () => {
                        if (delegationData.length >= 3) {
                            return showDialog({
                                description: THREE_SITE_PI_ALLOWED,
                                disableCancelButton: true,
                            });
                        }

                        setCiDelegationEdit(false);
                        setSelectedRow({});
                        setCiDelegationAddShow(true);
                    }}
                >
                    Add
                </CustomButton>
            </div>
            <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
                <CustomTable
                    fullWidthTable
                    columns={ciDelegationColumns}
                    rows={delegationData}
                    isDeleteAllow
                    isEditAllow
                    loading={isTableLoading}
                    disableDeleteConfirm
                    onDelete={onCiDelegateDelete}
                    onEdit={onEdit}
                />
            </div>
        </SLayout>
    );
};

export default CiDelegationEdit;
